module.exports = __webpack_public_path__ + "img/图片3.954604e4.png";